import { render } from "./PsLabelCaption.vue?vue&type=template&id=6f8e9e15&ts=true"
import script from "./PsLabelCaption.vue?vue&type=script&lang=ts"
export * from "./PsLabelCaption.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\DELL\\download\\advertisingServiceWebApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__